import Type7 from "./option";

export default Type7;
